import React, { useState, useEffect, useRef, useContext } from "react";

// context
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

// assets
import disabledIcon from "bodycodi/cmap/app/img/coment-send-disable.png";
import activeIcon from "bodycodi/cmap/app/img/icon_send_on.png";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const NewCommentInput = ({ communityId, seqPartnerCoach, refresh, autoFocus }: any) => {
  const { dispatch } = useContext(HomeDispatchContext);
  const inputRef = useRef<any>(null);
  const [active, setActive] = useState<boolean>(false);
  const [value, setValue] = useState<string>("");

  const registerNewComment = async () => {
    try {
      if (value.trim().length === 0) {
        return false;
      }
      api
        .post("/cmap4020/execCmntReg", { upldId: communityId, cmntCtnt: value, seqPartnerCoach })
        .then(() => {
          setActive(false);
          setValue("");
          refresh();
          dispatch({ type: "UPDATE_COMUNITY" });
        });
    } catch (error) {
      console.error(error);
    }
  };

  const calcHeight = (value: string, lineHeight: any) => {
    const cnt = (value.match(/\n/g) || []).length;
    const height = lineHeight * cnt + lineHeight;
    return height;
  };

  const autoHeight = (e: any) => {
    const value = e.currentTarget.value.trim();
    if (value.length != 0) {
      setActive(true);
    } else {
      setActive(false);
    }
    const lineHeight = Number(
      window!.getComputedStyle(e.currentTarget).lineHeight.replace("px", "")
    );
    const height = calcHeight(e.currentTarget.value, lineHeight);
    inputRef.current.style.height = `${height + 38}px`;
  };

  const blurTextarea = (e: any) => {
    const lineHeight = Number(
      window.getComputedStyle(e.currentTarget).lineHeight.replace("px", "")
    );
    inputRef.current.style.height = `${lineHeight + 38}px`;
  };

  return (
    <div className="comment-input-wrap">
      <div className="comment-input" ref={inputRef}>
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={autoHeight}
          onKeyUp={autoHeight}
          // onFocus={autoHeight}
          onBlur={blurTextarea}
          placeholder="댓글을 입력해 주세요 :)"
          maxLength={100}
          autoFocus={autoFocus}
        />
      </div>

      <div color="#fff" className="icon" onClick={active ? registerNewComment : () => {}}>
        <img src={active ? activeIcon : disabledIcon} />
      </div>
    </div>
  );
};

export default NewCommentInput;
